import script from "./ChatSharePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSharePage.vue?vue&type=script&setup=true&lang=js"

import "./ChatSharePage.vue?vue&type=style&index=0&id=521660e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-521660e2"]])

export default __exports__